module.exports = require('./browser-shims')
